export const ENTRY_DATA_SECTION_KEYS = {
  clinicalTrial: "Clinical Trials",
  clinicalTrialStatus: "Clinical Trial Status",
  regulatory: "Regulatory",
  deals: "Deals",
  dealsLaSc: "Deal LA&SC",
  expeditedProgram: "Expedited Program",
  ventureCapital: "Venture Capital",
  publication: "Publication",
  publicationJournal: "Publication Journal",
  conferenceSchedule: "Conference Schedule",
  companyWebsiteVariousPages: "Company Website Various Pages",
  dealFiling: "Deal Filing",
  fundingFiling: "Funding Filing",
  ctg: "CTG",
  regulatoryLabel: "Regulatory Label",
} as const;
